<template>
	<div>
		<!-- Displayed value -->
		<form-field-readonly
			@click="openModal"
			@remove:clicked="onUnselect"
			:hasRemove="computedValue ? true : false"
		>{{ computedValue ? computedValue : "---" }}</form-field-readonly>

		<!-- Modal -->
		<core-modal
			:name="instanceKey"
			headline="Select Entity"
			:pivotX="0"
			:pivotY="0"
			:hasHeader="false"
		>
			<div style="height:100vh; overflow: scroll;">
				<entity-picker
					:allowedEntityTypes="allowedEntityTypes"
					@entity:selected="$emit('input', $event.id), $modal.hide(instanceKey)"
				/>
			</div>
		</core-modal>
	</div>
</template>

<script>
import CoreModal from "@/modules/core/components/CoreModal"
import FormFieldReadonly from "../FormFieldReadonly.vue"
import EntityPicker from "../EntityPicker/EntityPicker"
import { getFieldData } from "../utils/index.js"

export default {
	components: {
		CoreModal,
		FormFieldReadonly,
		EntityPicker
	},

	props: {
		/**
		 * Value represents `id`
		 */
		value: {
			type: String
		},

		/**
		 * Field from schema
		 * It's an object that inlcudes numerous properties, read docs for more details
		 * We compute some values based on those properties
		 */
		field: {
			type: Object,
			default: () => ({})
		},

		allowedEntityTypes: {
			type: Array,
			default: () => ["individual", "company", "object"] // individual, company, object, participant, organization
		}
	},

	data() {
		return {
			instanceKey: Math.random().toString() // get unique key fro modal window
		}
	},

	computed: {
		/**
		 * Entity object that we get from API
		 * We get some other properties from this object that are crucial for some operations
		 * e.g. entityId, entityName, entityType via __typename
		 * thus it has to contain properties: `__typename`, `id` `name`
		 */
		entity() {
			const entity = getFieldData("entity", this.field, this)
			if (!entity)
				console.error(
					`There is no field.entity in ${this.field.label}, it will cause errors for adding and updating entity.`,
					this.field
				)
			return entity
		},

		/**
		 * Based on this we do API calls
		 */
		entityId() {
			return this.entity?.id
		},

		/**
		 * Based on this we do API calls
		 */
		entityType() {
			return this.entity?.__typename
		},

		/**
		 * When we need to display name of an entity
		 */
		entityName() {
			return this.entity?.name
		},

		/**
		 * So that we do not display `id` but proper value
		 */
		computedValue() {
			return this?.entity?.name
		}
	},

	methods: {
		// When user unselects
		onUnselect() {
			this.$emit("remove", this?.entity?.id)
			this.$modal.hide(this.instanceKey)
		},

		openModal() {
			this.$modal.show(this.instanceKey)
		}
	}
}
</script>
